/*
 * <campaign-countdown data-ends-at="2026-12-01T23:59:00+01:00">
 *
 * Ships `hidden`; this is what shows it. A missing or unparseable end date
 * leaves it hidden rather than counting towards nothing. Once the end has
 * passed it swaps to the "ended" line via `.is-over` and stops ticking.
 */
if (!customElements.get('campaign-countdown')) {
  customElements.define(
    'campaign-countdown',
    class CampaignCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.endsAt || '');
        if (Number.isNaN(this.end)) return;

        this.cells = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.cells[el.dataset.unit] = el;
        });

        this.tick();
        this.hidden = false;
        if (!this.classList.contains('is-over')) {
          this.timer = setInterval(() => this.tick(), 1000);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        if (left === 0) {
          this.classList.add('is-over');
          clearInterval(this.timer);
          return;
        }
        const pad = (n) => String(n).padStart(2, '0');
        this.set('days', pad(Math.floor(left / 86400)));
        this.set('hours', pad(Math.floor((left % 86400) / 3600)));
        this.set('minutes', pad(Math.floor((left % 3600) / 60)));
        this.set('seconds', pad(left % 60));
      }

      set(unit, value) {
        const el = this.cells[unit];
        if (el && el.textContent !== value) el.textContent = value;
      }
    }
  );
}
